// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading":"_1i3I_N"};